<template>
  <div class="settings" id="shot">
    <h1>{{ $t("langcfg.txtCaptureSettings") }}</h1>
    <br />
    <br />
    <br />
    <div style="text-align: left; margin-left: 40px">
      <span>{{ $t("langcfg.txtMode") }}:</span>
      <el-select v-model="selMode" placeholder="">
        <el-option
          v-for="item in captureModes"
          :key="item.key"
          :label="item.label"
          :value="item.key"
        >
        </el-option>
      </el-select>
      <el-button
        class="btn-operator"
        @click="resetAllCamLamp"
        :style="`width: ${isDE ? 300 : 200}px`"
        >{{ $t("langcfg.txtResetAll") }}</el-button
      >
    </div>
    <div class="div-border"></div>
    <div style="margin-left: 45px">
      <el-row>
        <el-col :span="12"> <cam-settings :currentMode="selMode"></cam-settings></el-col>
        <el-col :span="12"><lamp-settings :currentMode="selMode"></lamp-settings></el-col>
      </el-row>
    </div>
    <div class="div-border"></div>
    <eye-type-setting
      v-if="selMode === 'topography_near' || selMode === 'topography_far'"
      style="width: 100%; margin-bottom: -20px"
    />
    <Lipidlayer-settings v-if="selMode === 'lipidlayer'" style="width: 50%" />
    <NIBUTSetting v-if="selMode === 'nibut'" style="width: 100%" />
    <BUTSetting v-if="selMode === 'fbut'" style="width: 80%" />
    <BlinkSetting v-if="selMode === 'blink'" style="width: 80%" />
    <TearheightSetting v-if="selMode === 'tearheight' && isNewInfrared" style="width: 80%" />
    <SoundSetting />
  </div>
</template>

<script>
import CamSettings from "./CamSettings";
import LampSettings from "./LampSettings";
import LipidlayerSettings from "./LipidlayerSettings";
import TearheightSetting from "./TearheightSetting";
import NIBUTSetting from "./NIBUTSetting";
import BUTSetting from "./BUTSetting";
import BlinkSetting from "./BlinkSetting";
import SoundSetting from "./SoundSetting.vue";
import { DRYEYEMODES } from "../../../shared/consts";
import { isObject, objectCopy } from "../../../shared/utils";
import { CAMPLAMP, CAMPLAMP_OLD } from "../../../settings/consts";
import { saveCamSettings } from "../../../settings";
import { Message, License } from "../../../mixins";
import fileSys from "../../../fileoprators/fileSystem";
import SettingsOprator from "../../../settings/settingsoprator";
import EyeTypeSetting from "./EyeTypeSetting.vue";

export default {
  name: "Shot",
  components: {
    CamSettings,
    LampSettings,
    LipidlayerSettings,
    NIBUTSetting,
    BUTSetting,
    SoundSetting,
    BlinkSetting,
    EyeTypeSetting,
    TearheightSetting
  },
  props: {},
  data() {
    return {
      captureModes: [],
      selMode: "",
      selIndex: 0,
      isDE: false
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  updated() {
    this.isDE = window.settings.language === "de";
  },
  mixins: [Message, License],
  methods: {
    init() {
      if (this.isTopographyEnabled) {
        this.captureModes = [
          {
            key: "topography_near",
            label: `${this.$t("langcfg.txtTopography")}_${this.$t("langcfg.txtNear")}`
          },
          {
            key: "topography_far",
            label: `${this.$t("langcfg.txtTopography")}_${this.$t("langcfg.txtFar")}`
          },
          // { key: 'pupilcorneadia', label: `${this.$t('langcfg.txtPupilCorneaDiameter')}_${this.$t('langcfg.txtPhotopic')}` },
          // { key: 'pupilcorneadia_scotopia', label: `${this.$t('langcfg.txtPupilCorneaDiameter')}_${this.$t('langcfg.txtScotopic')}`},
          {
            key: "pupilcorneadia_dark",
            label: `${this.$t("langcfg.txtPupilCorneaDiameter")}_${this.$t(
              "langcfg.txtpupilcorneaDark"
            )}`
          },
          {
            key: "pupilcorneadia_lowerMiddle",
            label: `${this.$t("langcfg.txtPupilCorneaDiameter")}_${this.$t(
              "langcfg.txtpupilcorneaLowerMiddle"
            )}`
          },
          {
            key: "pupilcorneadia_middle",
            label: `${this.$t("langcfg.txtPupilCorneaDiameter")}_${this.$t(
              "langcfg.txtpupilcorneaMiddle"
            )}`
          },
          {
            key: "pupilcorneadia_bright",
            label: `${this.$t("langcfg.txtPupilCorneaDiameter")}_${this.$t(
              "langcfg.txtpupilcorneaBright"
            )}`
          },
          { key: "pupilcorneadia_dynamic", label: `${this.$t("langcfg.txtpupilcorneaDynamic")}` }
        ];
      }
      if (this.isDryEyeEnabled) {
        for (let key in DRYEYEMODES) {
          if (key === "questionnaire") {
            continue;
          }
          this.captureModes.push({
            key: DRYEYEMODES[key].key,
            label: this.$t(`langcfg.${DRYEYEMODES[key].label}`)
          });
        }
      }
      this.selMode = this.captureModes[0].key;
    },
    getDefaultCamLamp() {
      let toolsCalibCamPath = "/home/mw520/dea520/dea520_tools/dist/calib/camLampCfg.json";
      let settings = new SettingsOprator(toolsCalibCamPath, CAMPLAMP).getSettings();
      if (!window.isNewSN()) {
        settings.pupilcorneadia_dark = objectCopy(CAMPLAMP_OLD.pupilcorneadia_dark);
        settings.pupilcorneadia_lowerMiddle = objectCopy(CAMPLAMP_OLD.pupilcorneadia_lowerMiddle);
        settings.pupilcorneadia_middle = objectCopy(CAMPLAMP_OLD.pupilcorneadia_middle);
        settings.pupilcorneadia_bright = objectCopy(CAMPLAMP_OLD.pupilcorneadia_bright);
        settings.pupilcorneadia_dynamic = objectCopy(CAMPLAMP_OLD.pupilcorneadia_dynamic);
      }
      return settings;
    },
    resetAllCamLamp() {
      this.confirm(
        this.$t("langcfg.txtConfirmResetAll"),
        this.$t("langcfg.txtOK"),
        this.$t("langcfg.txtCancel")
      )
        .then(() => {
          window.camSettings = this.getDefaultCamLamp();
          saveCamSettings(window.camSettings);
          let backup = this.selMode;
          this.selMode = "";
          this.$nextTick(() => {
            this.selMode = backup;
            this.notify(this.$t("langcfg.txtResetOK"), "", "success");
          });
        })
        .catch((e) => {});
    }
  },
  watch: {},
  computed: {
    isNewInfrared() {
      return window.isNewInfrared();
    }
  },
  beforeDestory() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.settings {
  width: 100%;
  margin-top: 60px;
  margin-left: 15px;
  font-size: 28px;
  color: white;
  display: flex;
  align-items: left;
  flex-direction: column;
  z-index: 1000;
}
.settings-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  margin-top: 50px;
}
.btn-operator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-operator:active {
  background: @btn-active-color;
}

.btn-operator {
  border: 1px gray solid;
  height: @header-fs+22px;
  font-size: @header-fs;
}
</style>
<style lang="less">
#shot {
  .el-input__inner {
    font-size: 28px;
    line-height: 50px;
    background-color: #fff;
    height: 50px;
  }
  .div-border {
    widows: 100%;
    height: 5px;
    margin-left: 40px;
    margin-top: 30px;
    border-bottom: 1px solid rgba(128, 128, 128, 0.3);
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/Shot.vue